import { render } from "./CartRecapPromo.vue?vue&type=template&id=7c65d090"
import script from "./CartRecapPromo.vue?vue&type=script&lang=js"
export * from "./CartRecapPromo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__